// @ts-nocheck

import React from 'react';
import { connect } from 'react-redux';
import Head from 'react-helmet';
import styled from 'styled-components';
import { colors } from 'app/shared/styles/_colors';

import Container from 'app/shared/core/Container';
import Button from 'app/shared/core/Button';
import Section from 'app/shared/modules/Section';
import Row from 'app/shared/core/Row';
import Title from 'app/shared/modules/Title';
import Center from 'app/shared/modules/Center';
import stringHelper from 'app/shared/utils/stringHelper';
import Input from 'app/shared/core/Input';
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';
import AppActions from 'app/shared/flux/actions/AppActions';
import FetchListingActions from 'app/shared/flux/actions/FetchListingActions';
import ListingWrapper from 'app/shared/modules/listing-cards/ListingWrapper';
import Linker from 'app/shared/modules/Linker';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import pathsManifest from 'app/shared/utils/pathsManifest';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import { getGlobalLogger } from '@zg-rentals/logger-base';

const logger = getGlobalLogger('pages/reportListingAsUnavailablePage');
const StyledErrorDiv = styled.div`
  color: ${colors['$hpx-red-400']};
`;
class ReportListingAsUnavailablePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      aliasEncoded: '',
      reported: false,
      msg: '',
      errorMsg: '',
    };
  }

  componentDidMount() {
    const { dispatch, currentListing } = this.props;

    const urlQueryParams = stringHelper.getUrlQueryParams();
    if (urlQueryParams) {
      this.setState({ aliasEncoded: urlQueryParams.aliasEncoded });
    }

    if (currentListing && currentListing.maloneLotIdEncoded) {
      dispatch(
        FetchListingActions.fetchSimilarListings({
          maloneLotIdEncoded: currentListing.maloneLotIdEncoded,
          unit: currentListing.unit,
          listingTypes: currentListing.listingType,
        }),
      );
    }
  }
  serverRouteWillMount(reactContext) {
    const store = reactContext.store;
    const dispatch = store.dispatch;
    const aliasEncoded = reactContext.state.query.aliasEncoded;

    const promises = [];

    if (aliasEncoded) {
      promises.push(
        dispatch(FetchListingActions.fetchListingByAliasEncoded({ aliasEncoded, shouldSkipRedirect: true }))
          .then((response) => {
            const listing = response.listing;

            if (!listing) {
              return false;
            }

            return dispatch(ListingEngineActions.setCurrentListing(listing));
          })
          .catch((error) => {
            dispatch(
              ErrorActions.errorHandler({
                error,
                errorLocation: 'component.reportListingAsUnavailablePage.serverRouteWillMount',
                errorClass: 'listingEngineActions',
              }),
            );
          }),
      );
    }

    return promises;
  }
  report() {
    const params = {
      alias: this.state.aliasEncoded,
      type: 'notAvailable',
      message: this.state.msg,
    };
    this.props
      .dispatch(ListingEngineActions.sendReport(params))
      .then(() => {
        this.props.dispatch(
          AppActions.toggleNotificationMessage({
            content: 'This listing has been reported.',
          }),
        );
        this.setState({ reported: true });
      })
      .catch((err) => {
        const msg = 'Something went wrong reporting the listing... please try again later.';
        logger?.warn(err, msg);
        this.setState({
          errorMsg: msg,
        });
      });
  }

  updateMessage(e) {
    this.setState({ msg: e.target.value });
  }

  renderSimilarListings(listings) {
    return map(listings, (similarListing, i) => {
      return <ListingWrapper listing={similarListing} key={i} />;
    });
  }

  reportForm(currentListing) {
    return (
      <div>
        <Row>Did the landlord not respond to you, or did they say the property wasn't available?</Row>
        <Row>Let us know about {currentListing.displayName} so we can follow up!</Row>
        <Row>
          <Input
            label="Any additional information you can give us"
            maxLength={150}
            onChange={(e) => this.updateMessage(e)}
            type="text"
            fixedSize
            value={this.state.msg}
          />
        </Row>
        <Row>
          <Button onClick={(e) => this.report()}>{this.state.reported ? 'Reported!' : 'Report as Unavailable'}</Button>
        </Row>
        {this.state.errorMsg && (
          <Center>
            <StyledErrorDiv>{this.state.errorMsg}</StyledErrorDiv>
          </Center>
        )}
      </div>
    );
  }

  reported(similarListings) {
    return (
      <div>
        <Row>Thanks for your report - we'll investigate!</Row>
        {!isEmpty(similarListings) && (
          <div>
            <Row>Try checking out some of these nearby available properties:</Row>
            {this.renderSimilarListings(similarListings)}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { currentListing, similarListings } = this.props;

    if (currentListing) {
      return (
        <div className="ReportListingAsUnavailablePage">
          <Head title="Report a listing | HotPads" />
          <Container>
            <Section>
              <Title size="lg">Didn't hear back from {currentListing.displayName}?</Title>
            </Section>
            <div className="ReportListingAsUnavailablePage-content">
              {!this.state.reported && this.reportForm(currentListing, this.state.msg)}
              {this.state.reported && this.reported(similarListings)}
            </div>
          </Container>
        </div>
      );
    } else {
      return (
        <div className="ReportListingAsUnavailablePage">
          <Head title="Report a listing | HotPads" />
          <Container>
            <Section>
              <Row>The property you were trying to report is no longer listed on HotPads.</Row>
              <Row>
                <Linker to={pathsManifest.FrontPage}>Continue your search!</Linker>
              </Row>
            </Section>
          </Container>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  currentListing: state.currentListingDetails.currentListing,
  similarListings: state.fetchListing.similarListings,
});
export default connect(mapStateToProps)(ReportListingAsUnavailablePage);
